import { TabStyles } from '@tableau/widgets';

import { cssClass } from '../../../../style';


const prefix = 'dialog-alert';

export namespace DialogAlertStyles {

  export const containerStyle = cssClass(prefix, 'container', {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '8px',
    paddingLeft: '4px'
  });

  export const messageStyle = cssClass(prefix, 'message', {
    paddingLeft: '8px',
    lineHeight: `${TabStyles.Typography.Sizing.XLarge}px`,
    whiteSpace: 'pre-line'
  });

  export const image = cssClass(prefix, 'image', {
    paddingLeft: TabStyles.Spacing.DefaultSpace,
    height: TabStyles.Typography.Sizing.XLarge
  });

  export const errorStyle = generateStyle('error', '#f9ebec', '#c93a47');
  export const warningStyle = generateStyle('warning', '#fef9ef', '#feca63');
  export const infoStyle = generateStyle('info', '#eef5f9', '#2a79af');
}

function generateStyle(className: string, backgroundColor: string, borderColor: string) {
  return cssClass(prefix, className, {
    backgroundColor: backgroundColor,
    borderLeft: `4px solid ${borderColor}`,
  });
}
